@for (day of daysOfTheWeekOptions(); track day.value) {
  <button
    nz-button
    nzType="default"
    nzSize="small"
    nzShape="circle"
    [disabled]="disabled()"
    [class.selected]="day.checked"
    [class.small]="small()"
    (click)="onDayOfTheWeekClick(day.value)"
  >
    {{ (day.label | translate).charAt(0) }}
  </button>
}
